module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sweet-modal-tab', {
      active: _vm.active
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-fc5e7e9c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./~/_sweet-modal-vue@1.2.0@sweet-modal-vue/src/components/SweetModalTab.vue
// module id = 169
// module chunks = 25 26 35